<div class="audit-log-header" data-testId="date-range">
  <div data-testId="date-range-start">
    <mat-form-field appearance="fill" class="date-range">
      <mat-label>Start Date</mat-label>

      <input
        matInput
        [min]="startMinDate"
        [max]="startMaxDate"
        [readonly]="true"
        [matDatepicker]="startDate"
        (dateChange)="startDateEvent($event)"
        data-testId="start-date-input"
        [(ngModel)]="defaultStartDate"
      />

      <mat-datepicker-toggle
        matSuffix
        [for]="startDate"
        [disabled]="false"
      ></mat-datepicker-toggle>
      <mat-datepicker
        #startDate
        [startAt]="startDate"
        [disabled]="false">
      </mat-datepicker>
    </mat-form-field>
  </div>

  <div data-testId="date-range-end">
    <mat-form-field appearance="fill" class="date-range">
      <mat-label>End Date</mat-label>

      <input
        matInput
        [min]="endMinDate"
        [max]="endMaxDate"
        [readonly]="true"
        [matDatepicker]="endDate"
        (dateChange)="endDateEvent($event)"
        data-testId="end-date-input"
        [(ngModel)]="defaultEndDate"
      />
      <mat-error> {{endErrorMessage}} </mat-error>

      <mat-datepicker-toggle
        matSuffix
        [for]="endDate"
        [disabled]="false">
      </mat-datepicker-toggle>

      <mat-datepicker
        #endDate
        [startAt]="endDate"
        [disabled]="false">
      </mat-datepicker>

    </mat-form-field>

  </div>

  <div>
    <button
      mat-raised-button
      color="primary"
      class="audit-filter-btn"
      (click)="sendRangeDate()"
      data-testId="filter-button"
      [disabled]="!allowFetch"
    >
      Search
    </button>
  </div>
</div>
